(() => {
    class Diashow extends App.Component {
        constructor(element) {
            super(element);
            this.update();

            /* GLOBALIZE */
            App.Components.wait(this.container, 'Instance', I => App.Components.Diashow = I);
        }

        /* Layout */
        get imageContainer() { return this.container.querySelector('.diashow-image-container') }

        get videoContainer() { return this.container.querySelector('.diashow-video-container') }

        /* Getters and Setters */
        get image() {
            if(!this._image) this._image = this.container.querySelector('.diashow-image');
            return this._image;
        }

        set image(image) {
            this.image.src = image;
        }

        get video() {
            if(!this._video) this._video = this.videoContainer.querySelector('.vimeo-iframe');
            return this._video;
        }

        set video(video) {
            this.video.src = video;
        }

        isVideoAllowed() {
            return ($.cookie('cookies_consent_performance') === 'true' && $.cookie('cookies_consent_targeting') === 'true');
        }

        swapImage(image, transparent = true, vimeoId = '') {
            if (vimeoId && this.videoContainer) {
                this.imageContainer.classList.add('hidden');
                this.videoContainer.classList.remove('hidden');
                this.video.src = this.video.dataset.vimeoSrc;
            } else {
                this.image = image;
                if (this.videoContainer && this.isVideoAllowed()) {
                    this.imageContainer.classList.remove('hidden');
                    this.videoContainer.classList.add('hidden');
                    this.video.src = '';
                }
                this.image.classList.toggle('non-transparent', !transparent);
            }
        }

        bind() {
            this.$.on('click', '.js-diashow-thumbnail', event => {
                this.swapImage(event.target.dataset.image, event.target.classList.contains('transparent'), event.target.dataset.vimeoId);
                this.container.querySelectorAll('.active')
                    .forEach(element => element.classList.remove('active'));
                event.target.classList.add('active');
            });

            if (this.isVideoAllowed()) {
                this.container.querySelectorAll('.js-diashow-thumbnail').forEach(thumbnail => {
                    if (thumbnail.dataset.vimeoId) {
                        new Promise((resolve, reject) => {
                            return fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${thumbnail.dataset.vimeoId}`).then(response => {
                                if (response.ok) {
                                    return response.json().then((data) => {
                                        thumbnail.src = data.thumbnail_url;
                                        thumbnail.dataset.image = data.thumbnail_url;
                                        thumbnail.style.backgroundImage = `url(${data.thumbnail_url})`;
                                        return data;
                                    }).catch((err) => {
                                        throw new Error('error');
                                    });
                                } else {
                                    reject(new Error('error'));
                                }
                            }, error => {
                                reject(new Error(error.message));
                            });
                        });
                    }
                });
            }
            return this;
        }

        build() {
            App.Interface.Resources.image(this.image.src).then(() => {
                const height = this.image.offsetHeight;
                if (this.videoContainer) {
                    this.videoContainer.querySelector('.vimeo-wrapper').style.height = height + 'px';
                    const thumbnail = this.container.querySelector('[data-name="video"]');

                    if (thumbnail) {
                        if (this.isVideoAllowed()) {
                            thumbnail.classList.remove('hidden');
                        } else {
                            thumbnail.classList.add('hidden');
                        }
                    }
                }
            });
            return this;
        }

        update() {
            this
                .build()
                .bind()
            ;
        }
    }
    App.Components.register('.diashow', Diashow);
})();
